module.exports = __webpack_public_path__ + "static/media/chat-menu-accordion-toggle-close.fcee6519.svg";